import { ProjectId } from "@taskin-code/contracts";
import { createFileRoute } from "@tanstack/react-router";
import { ProjectAgentsView } from "~/components/agents/ProjectAgentsView";
export const Route = createFileRoute("/_chat/projects/$projectId/agents")({
  component: () => (
    <ProjectAgentsView fixedProjectId={ProjectId.makeUnsafe(Route.useParams().projectId)} />
  ),
});
